/**
 * Server functions for the code-rendered docs pages (the API reference). Not
 * marked `server-only`: the client imports these as RPC stubs and the compiler
 * strips the handler bodies.
 */
import { createServerFn } from '@tanstack/react-start'

import {
  type ApiReference,
  getApiReferenceData,
} from '@/lib/docs/api-reference.server'

export const getApiReference = createServerFn({ method: 'GET' }).handler(
  (): Promise<ApiReference> => getApiReferenceData(),
)
